import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { FormFlowPage, TextInput } from "src/components";

import { usePartialSubmit } from "../hooks";
import { styles } from "../styles";

export interface ExistingLoansAmountProps {
  value?: string;
  onChange?: (value?: string) => void;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const ExistingLoansAmount = ({
  value,
  onChange,
  onNext,
  onBack,
  style,
  focusRef,
  ...props
}: ExistingLoansAmountProps) => {
  const validate = useCallback(() => !!value, [value]);
  const { handleNext, nextDisabled, nextLoading } = usePartialSubmit({ onNext, validate });

  return (
    <FormFlowPage
      {...props}
      title="How much are your existing home loans?"
      description="A ball-park estimate should do the trick."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
    >
      <TextInput
        currency
        ref={focusRef}
        style={styles.input}
        name="loanAmount"
        label="Existing loan amount"
        placeholder="85,000"
        value={value || ""}
        onChange={onChange}
      />
    </FormFlowPage>
  );
};

export default memo(ExistingLoansAmount);
